import { IconId } from '../icon/icons';
import useAppSelector from '../../hooks/useAppSelector';
import Icon from '../icon/Icon';
import './ActiveHelpBubble.less';
import ActiveHelpProductList from './ActiveHelpProductList';
import Button from '../button/Button';
import IconButton from '../button/IconButton';
import useAppDispatch from '../../hooks/useAppDispatch';
import { dispatchEvent } from '../../services/EventService';
import { useTranslation } from '../../hooks/useTranslation';

export type ActiveHelpBubbleProps = {
    className?: string;
};

const ActiveHelpBubble = ({ className = '' }: ActiveHelpBubbleProps) => {
    const { isInitialized, isVisible, scenarioName, currentActiveHelp } =
        useAppSelector(state => state.activeHelpState);
    const { mode, position } = useAppSelector(state => state.uiState);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const {
        title = '',
        description = '',
        activeHelpType,
        iconId = null
    } = currentActiveHelp ?? {};
    const totalProducts =
        currentActiveHelp &&
        currentActiveHelp.activeHelpType === 'product-search-combinations'
            ? currentActiveHelp.totalProducts
            : 0;
    const products =
        currentActiveHelp &&
        currentActiveHelp.activeHelpType === 'product-search-combinations'
            ? currentActiveHelp.productsSample
            : [];
    const isFullClickable = true; // TODO: remove this if unnecessary

    const dispatchClickActiveHelpEvent = () => {
        dispatchEvent({
            type: 'bri.click_active_help',
            isInteraction: true,
            scenarioName,
            activeHelpDescription: description,
            activeHelpTitle: title
        });
    };

    if (!isInitialized || mode !== 'button') {
        return null;
    }
    return (
        <div
            className={`bri-ActiveHelpBubble ${className} bri-ActiveHelpBubble-position-${position} ${
                isVisible ? 'bri-visible' : ''
            } ${isFullClickable ? 'bri-clickable' : ''}`}
            {...(isFullClickable && {
                onClick: () => {
                    dispatchClickActiveHelpEvent();
                    dispatch.activeHelpState.applyActiveHelpClick();
                    dispatch.activeHelpState.hide();
                }
            })}
        >
            {iconId && (
                <div className="bri-ActiveHelpBubble-icon">
                    <Icon iconId={iconId as IconId} />
                </div>
            )}
            {title && <div className="bri-BodyFont">{title}</div>}
            {description && (
                <div className="bri-Body2Font bri-ActiveHelpBubble-description">
                    {description}
                </div>
            )}
            {products.length > 0 && (
                <ActiveHelpProductList products={products} />
            )}
            {activeHelpType === 'product-search-combinations' && (
                <Button
                    variant="secondary"
                    size="medium"
                    onClick={() => void 0}
                >
                    {totalProducts === 1
                        ? t('ACTIVE_HELP_VIEW_PRODUCTS_BUTTON_TEXT_ONE')
                        : t('ACTIVE_HELP_VIEW_PRODUCTS_BUTTON_TEXT_MANY', {
                              count: totalProducts
                          })}
                </Button>
            )}

            <IconButton
                variant="light"
                className="bri-ActiveHelpBubble-close-button"
                iconId="close"
                raised
                onClick={event => {
                    event.stopPropagation();
                    dispatchEvent({
                        type: 'bri.close_active_help',
                        isInteraction: false,
                        scenarioName,
                        activeHelpDescription: description,
                        activeHelpTitle: title
                    });
                    dispatch.activeHelpState.hide();
                }}
            />
        </div>
    );
};

export default ActiveHelpBubble;
